// choices/endChoices.js
const endChoicesRo = [
  {
    label: "Descoperă-ți culorile",

    value: "results",
  },
  {
    label: "Să le specializăm și mai mult",
    value: "large",
  },
];

export default endChoicesRo;
